import type { StoreRootState } from "..";

export const configStateSelector = (state: StoreRootState) =>
  state.config;

const configSelector = (state: StoreRootState) =>
  state.config.data;

export default configSelector;